import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Splash from 'partial/containers/Splash';
import { ProfileContext } from '../constants';
import { useGetProfile } from '../hooks';

function ProfileWrapper({ children }) {
  const [profile, getProfile] = useGetProfile();
  const value = useMemo(
    () => ({
      profile,
      getProfile,
    }),
    [profile, getProfile],
  );
  if (!profile) return <Splash />;
  return (
    <ProfileContext.Provider value={value}>{children}</ProfileContext.Provider>
  );
}

ProfileWrapper.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
};

export default ProfileWrapper;
